module.exports = __webpack_public_path__ + "static/scale-model-of-magic-bus-san-francisco-in-san-francisco-california-c883c130a0ff40107bc953baba94c86e.png";